import { render, staticRenderFns } from "./editNumber.vue?vue&type=template&id=2b7f71b8&scoped=true"
import script from "./editNumber.vue?vue&type=script&lang=js"
export * from "./editNumber.vue?vue&type=script&lang=js"
import style0 from "./editNumber.vue?vue&type=style&index=0&id=2b7f71b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f71b8",
  null
  
)

export default component.exports